import './DCMV1.css'
import * as React         from 'react'
import {
  Chip,
  Tooltip,
  Icon,
}                         from "@material-ui/core"
import {
  withLocalize,
  LocalizeContextProps
}                         from "react-localize-redux"
import {
  DCMV1FeedParams,
}                         from "../../../model/feed/Feed"
import FeedSummaryProps   from "./props"
import LangChip           from "./LangChip"
import InactiveChip       from "./InactiveChip"

interface FeedSummaryDCMV1Props extends LocalizeContextProps, FeedSummaryProps<DCMV1FeedParams>{
  isMI : boolean
}

const FeedSummaryDCMV1 = (props:FeedSummaryDCMV1Props) => {
  const deletionLocked = props.urls.some( url => url.isLocked )

  return (
    <div className='FeedSummary'>
      <Tooltip placement="top" title={<p>{props.translate("feeds.tooltip.DCM")}</p>}>
        <img className="DCM" src="./assets/img/google-campaign-manager.svg"/>
      </Tooltip>
      {props.isMI &&
        <Tooltip placement="top" title={<p>{props.translate("feeds.tooltip.MOTOINSIGHT")}</p>}>
          <img className="DCM" src="./assets/img/motologo.png"/>
        </Tooltip>
      }
      <Tooltip placement="top" title={<p>{props.translate("feeds.tooltip.vehicleType")}</p>}>
        <Chip color="primary" variant="outlined" label={props.translate("feeds.vehicleType."+props.config.params.vehicleType)}/>
      </Tooltip>
      <Tooltip placement="top" title={<p>{props.translate("feeds.tooltip.vehicleState")}</p>}>
        <Chip color="primary" variant="outlined" label={props.translate("feeds.vehicleState."+props.config.params.vehicleState)}/>
      </Tooltip>
      <LangChip lang={props.config.params.lang} inventoryLang={props.config.params.inventoryLang}/>
      <InactiveChip active={props.urls.length!==0}/>
      {
        deletionLocked &&
          <Tooltip placement="top" title={<p>{props.translate('feeds.deleteLocked')}</p>}>
            <div className="AlignCenter">
              <Icon style={{color: "gray"}}>lock</Icon>
            </div>
          </Tooltip>
      }
    </div>
  )
}
export default withLocalize(FeedSummaryDCMV1)
